export const api="https://e-avtomaktab.uz"
// export const apiNew="https://localhost:7252"
export const apiNew="https://e-test.uz"
export const apiFace="https://e-test.uz"
export const apiImage="https://e-test.uz"